<template>
  <el-card>
    <template v-slot:header>
      <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>GO enrichment analysis</span>
      </div>
    </template>
    <div class="container">
      <el-container>
          <el-main>
            <div id="go" style="width:100%;height:500px;"></div> 
          </el-main>
      </el-container>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    species: {
      type: String,
      required: true
    },
    tissue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartData: [], // 用来存放图表数据的变量
      url: "http://183.175.59.4/devenhancer/",// 后端接口地址
    }
  },
  mounted() {
    this.handleAnalysis();
  },
  methods: {
    handleAnalysis() {
      //1. 向后端请求数据
      const params = { Species: this.species, Tissue: this.tissue}
      this.$axios.get(this.url + "goanalysis" + "/", { params }).then(response => {
        const displayedData = response.data; 
        this.chartData = displayedData; // 将数据赋值给chartData
        let yAxisSet = new Set(); // 创建 Set 对象用于存储唯一值
        displayedData.forEach(item => {
          yAxisSet.add(item.Description); // 将 Description 添加到 Set 中
        });
        const yAxisData = Array.from(yAxisSet); // 将 Set 转换为数组
        const xAxisData = displayedData.map(item => -Math.log10(item.pvalue)); // X轴数据为pvalue
        const newChart = this.$echarts.init(document.getElementById('go')) // 创建新的实例
        const option = {
          tooltip: {},
          grid: {
            left: '25%',
            right: '10%',
            top: '10%',
            bottom: '10%'
          },
          xAxis: {
            type: 'value',
            name: '-log10 (pvalue)',// 设置y轴名称为-log10（pvalue） 
            axisLabel: {
              show: true,  // 设置为展示内容
              fontSize: 13, // 设置 x 轴字体大小为 12px
              color:'#000',
            },
            axisTick: {
              show:true,
              interval: 0.3, // 控制每个刻度之间的间隔大小
            },
            splitLine: { show: false }, // 隐藏网格 
          },
          yAxis: { 
            type: 'category',
            name:'description',
            data: yAxisData, 
            axisLabel: {
              show: true,  // 设置为展示内容
              fontSize: 13, // 设置 x 轴字体大小为 12px
              color:'#000',
            },
            splitLine: { show: false }, // 隐藏网格 
          },
          series: [{
            data: xAxisData,
            type: 'bar',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: '#1AACAC'
              }, {
                offset: 1,
                color: '#005F83'
              }])
            }
          }]
        }
        newChart.setOption(option)
      }).catch(error => {
        console.error(error)
        this.$message.error('Failed to fetch data.')
      })
    },
  }
}  
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/seAnalysis/Go.vue